// Remove undefined attributes from an object,
// useful as we often support different combinations of attributes depending on products and auth strategy
export const removeUndefinedAttributes = (attributes) => {
    const cleanedAttributes = { ...attributes };
    Object.keys(cleanedAttributes).forEach((key) => cleanedAttributes[key] === undefined ? delete cleanedAttributes[key] : {});
    return cleanedAttributes;
};
